
import React from 'react';

const DownloadButton = ({
  label = '',
  width = 'w-auto',
  bgColor = 'bg-white',
  rounded = 'rounded-md',
  textcolor = 'text-[#212121]',
  hoverColor = 'hover:border-[#1976D2] hover:text-[#1976D2]',
  Icon: Icon = null,
  onClick = () => { }
}) => {
  return (
    <button onClick={onClick} className={`flex items-center py-2 px-4 text-sm border border-[#D1D5DB] rounded-md font-medium text-[#212121] w-full md:w-auto ${rounded} ${textcolor} ${bgColor} ${hoverColor} ${width}`}>
      {Icon &&
        <span className="mr-2">
          <Icon size={20} />
        </span>
      }
      {label}
    </button>
  );
};

export default DownloadButton;
